<div class='dialog-container' [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <h1 mat-dialog-title class='dialog-title' fxLayout='row wrap' fxLayoutAlign='space-between center'>
		<span class='title' *ngIf='dialogData.contentType === contentTypes.notifications'>
			{{ 'CUSTOM_CONTENT.vrmNotification' | translate }}
		</span>
    <span class='title' *ngIf='dialogData.contentType === contentTypes.tooltips'>
			{{ 'AGGRIDLOCALE.tooltips' | translate | uppercase }}
		</span>

    <small class='count'>
      {{ currentIndex + 1 }} {{ 'CUSTOM_CONTENT.of' | translate }}
      {{ dialogData.contents.length }}
    </small>
  </h1>

  <div class='content-wrapper'>
    <div class='nav-controls'>
      <div
        class='image-nav-round-bg'
        [class.invisible]='dialogData.contents.length == 0 || currentIndex == 0'
        (click)='previousContent()'
      >
        <mat-icon [style.color]="'#' + cService.userProfile?.HqColour">navigate_before</mat-icon>
      </div>
      <div
        class='image-nav-round-bg'
        [class.invisible]='dialogData.contents.length == 0 || currentIndex == dialogData.contents.length - 1'
        (click)='nextContent()'
      >
        <mat-icon [style.color]="'#' + cService.userProfile?.HqColour">navigate_next</mat-icon>
      </div>
    </div>

    <div fxLayout='row' class='content' *ngIf='dialogData.contentType === contentTypes.notifications'>
      <div>
        <h2>{{ currentMessage.notificationTitle || currentMessage.contentTitle }}</h2>
        <p>
          {{ currentMessage.notificationContent || currentMessage.contentMessage }}
        </p>
      </div>
    </div>

    <div
      fxFlex
      fxLayout='row'
      fxLayoutAlign='center center'
      *ngIf='dialogData.contentType === contentTypes.tooltips'
      class='padding-10'
    >
      <tooltip-viewer
        [title]='currentMessage.contentTitle'
        [description]='currentMessage.contentMessage'
      ></tooltip-viewer>
    </div>
  </div>

  <div mat-dialog-actions fxLayout='row' fxLayoutAlign='center center' class='actions'>
    <button mat-button vrm-button (click)='continueToNextContent()' style='color: white; padding-right: 0'>
      {{ 'CUSTOM_CONTENT.continue' | translate }}
    </button>
  </div>
</div>
